import vue from 'vue'
const login = {
  state: {
		userInfo: '',
		isComplate:false,
		roles:'',
		projRoles:[],
		curProjRoles:[],
		curProjRoleId:'',
		newrouter:[],
  },
  mutations: {
		SET_USERINFO:(state, userInfo) => {
			state.userInfo = userInfo;
		},
		SET_ROLES:(state, roles) => {
			state.roles = roles;
		},
		SET_PROJ_ROLES:(state, projRoles) => {
			state.projRoles = projRoles;
		},
		SET_CUR_PROJ_ROLES:(state, curProjRoles) => {
			state.curProjRoles = curProjRoles;
		},
		SET_CUR_PROJ_ROLE_ID:(state, roleId)=>{
			state.curProjRoleId = roleId
		},
		SET_NEWROUER:(state, newrouter) =>{
			state.newrouter = newrouter;
		},
		SET_IS_COMPLATE:(state,isComplate)=>{
			state.isComplate = isComplate;
		}
  },
  actions: {
		setUserInfo({commit},userInfo){
			sessionStorage.setItem('USERINFO',JSON.stringify(userInfo))
			commit('SET_USERINFO',userInfo)
		},
		setCurProjRoleId({commit},roleId){
			commit('SET_CUR_PROJ_ROLE_ID',roleId)
		},
		Logins({ commit }, state){
			return new Promise((resolve, reject) => {
				const params = {
					account:state.account,
					password:state.password,
					code:state.code
				}
				vue.prototype.$doRequest({
					url: '/web/user/login',
					method: 'post',
					data:params
				}).then(res => {
					sessionStorage.clear();
					resolve(res);
				}).catch(error => {
					reject(error);
				});
			});
		},
		checkLogin({ commit }, state){
			return new Promise((resolve, reject) => {
				vue.prototype.$doRequest({
					url: '/web/user/checkLogin',
					method: 'get'
				}).then(res => {
					resolve(res);
				}).catch(error => {
					reject(error);
				});
			});
		},
		getRole({ commit }, state){
			return new Promise((resolve, reject) => {
				if (sessionStorage.getItem('CUR-ROLE-PMS-TREE')){
					const curRolePmsTree = JSON.parse(sessionStorage.getItem('CUR-ROLE-PMS-TREE'))
					const prjRoleList = JSON.parse(sessionStorage.getItem('PRJ-ROLE-LIST'))
					commit('SET_ROLES', curRolePmsTree)
					commit('SET_CUR_PROJ_ROLES', prjRoleList)
					resolve(curRolePmsTree)
				}else{
					vue.prototype.$doRequest({
						url: '/web/permission/list/queryRoleAndPrjRolePermissionList',
						method: 'post',
						data:{
							roleId:'',
							roleType:0
						}
					}).then(res => {
						if(res.success){
							const curRolePmsTree = res.result.curRolePmsTree
							const prjRoleList = res.result.prjRoleList
							if (curRolePmsTree && curRolePmsTree.length > 0) { // 验证返回的roles是否是一个非空数组
								sessionStorage.setItem('CUR-ROLE-PMS-TREE',JSON.stringify(curRolePmsTree))
								commit('SET_ROLES', curRolePmsTree)
							} else {
								reject('getRole: roles must be a non-null array !')
							}
							if (prjRoleList && prjRoleList.length > 0) { // 验证返回的roles是否是一个非空数组
								sessionStorage.setItem('PRJ-ROLE-LIST',JSON.stringify(prjRoleList))
								commit('SET_CUR_PROJ_ROLES', prjRoleList)
							}
							resolve(curRolePmsTree)
						}
					}).catch(error => {
						reject(error);
					})
				}
			})
		},
		getProjRole({commit} ,state){
			commit('SET_CUR_PROJ_ROLES', state)
		},
		Logout({ commit }) {
			return new Promise((resolve, reject) => {
				vue.prototype.$doRequest({
					url: '/web/user/logout.do',
					method: 'post'
				}).then(() => {
					commit('SET_ROLES',[]);
					sessionStorage.clear();
					resolve();
				}).catch(error => {
					reject(error);
				})
			})
		},
		// 前端 登出
		FedLogOut({ commit }) {
			return new Promise(resolve => {
				removeToken()
				sessionStorage.clear();
				resolve()
			})
		}
  }
}
export default login;


// WEBPACK FOOTER //
// ./src/store/modules/login.js